import OwnerRoute from "../common/components/OwnerRoute";
import Expenses from "./pages/Expenses";

const expenseRoutes = [
  {
    path: "/expenses",
    element: (
      <OwnerRoute>
        <Expenses />
      </OwnerRoute>
    ),
  },
];

export default expenseRoutes;
